import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
 
import { EMPTY, Observable, from, throwError } from 'rxjs';
import { switchMap, catchError, finalize } from 'rxjs/operators';
 
import { AuthService } from '../../services/auth.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import { NRLoaderService } from 'src/app/shared/components/nr-loader/services/nr-loader.service';
 
@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  apiCount = 0;

  constructor(
    private authService: AuthService,
    private errorHandler: ErrorHandlerService,
    private nrLoaderService: NRLoaderService
  ) {}
 
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
 
    this.apiCount++;
    if (JSON.parse(request.headers.get('isLoaderRequired') as string)) {
      this.nrLoaderService.showLoader();
    }
    return from(this.authService.getTokens()).pipe(
      switchMap(tokens => {
        const updatedRequest = request.clone({
          setHeaders: {
            Authorization: `Bearer ${tokens.accessToken}`,
            IdToken: tokens.idToken
          }
        });
        return next.handle(updatedRequest);
      }),
      catchError((error: HttpErrorResponse) => {
        //  401 handling
        if (error.status === 401) {

          if (request.headers.has('x-retry')) {
            this.authService.loginRedirect();
            return EMPTY;
          }

          return from(this.authService.getTokens()).pipe(
            switchMap((tokens) => {
              const updatedRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${tokens.accessToken}`,
                  IdToken: tokens.idToken,
                  'x-retry': 'true'
                }
              });

              return next.handle(updatedRequest);
            }),
            catchError((err) => {
              console.error('Retry after 401 failed:', err);
              this.authService.loginRedirect();
              return EMPTY;
            })
          );
        }
        // network failure handling
        if (
          error.status === 0 ||
          error.message?.includes('ERR_CONNECTION_CLOSED')
        ) {
          location.reload();
          return EMPTY;
        }

        this.errorHandler.handle(error);
        return throwError(() => error);
      }),
 
      finalize(() => {
        this.apiCount--;
        if (this.apiCount === 0) {
          this.nrLoaderService.hideLoader();
        }
 
      })
    );
  }
}